/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";

interface Arguments {
  recycler_uid: string;
  recycler_location_uid: string;
  employee_uid: string;
  consumer_uid: string;
  conversation_uid: string;
  fs36_doc_id: string;
  conversation_invite_url: string;
}

function createUpdatePaymentLink( {
  recycler_uid,
  recycler_location_uid,
  employee_uid,
  conversation_uid,
  consumer_uid,
  fs36_doc_id,
  conversation_invite_url
}: Arguments) {
  return new Promise(function (resolve, reject) {
    let params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      firebase_email: window.G_firebase_auth.IV_email_address,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
      employee_uid: employee_uid,
      consumer_contact_uid: consumer_uid,
      conversation_uid: conversation_uid,
      p1s3e22_payment_link_uid: fs36_doc_id,
      p1s3e22_conversation_invite_url: conversation_invite_url
    };

    ajax({
      url: window.G_cloud_p1s3_base_url + "p1s3e22UpdatePaymentLink",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,

      success: function (result) {
        let response_data = {
          success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },

      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s3e22.ts",
          class_name: "p1s3e22",
          method_name: "createUpdatePaymentLink",
          error_title: "Failed to create / update Payment Link",
          error_description:
            "The server responded with an error when trying to create or update a payment link",
        };

        httpsLogger(error_data);
        reject(error_data);
      }
    });
  });
}

export default createUpdatePaymentLink;
